import { ArrowLeftCircleIcon, ArrowRightCircleIcon, PencilSquareIcon } from '@heroicons/react/24/outline'
import Notes from 'pages/Loan/Servicing/Notes/Notes'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { getOpenLoanDisplayNo } from 'utils'

import { floaterPanelEdgeClass, floaterTabEdgeClass, FloaterTabWrapper, useFloaterTab } from './useFloaterTab'

export const NotesSlide = () => {
  const loanDetail = useSelector((state: any) => state.loanDetail)
  const [isShowSlide, setShowSlide] = useState(false)
  const floater = useFloaterTab('notes', { side: 'right', percent: 25, offset: 60, mobileTop: 304 })

  const onShowSlide = () => {
    setShowSlide(!isShowSlide)
  }

  return (
    <>
      <FloaterTabWrapper floater={floater}>
        <button
          className={`p-3 ${floaterTabEdgeClass(
            floater.side,
          )} ring-[1px] ring-shade-blue bg-shade-blue text-white border hover:bg-white border-shade-blue hover:text-shade-blue rounded flex items-center gap-2 w-auto sm:w-[155px]`}
          {...floater.tabProps(onShowSlide)}
        >
          <PencilSquareIcon className="w-6 h-6" />
          <span className="hidden sm:inline">Notes</span>
        </button>
      </FloaterTabWrapper>
      {isShowSlide && (
        <div
          className={`shadow1 fixed bg-white border z-50 top-[5vh] bottom-0 w-[96rem] max-w-full h-[90vh] overflow-auto ease-in-out ${floaterPanelEdgeClass(
            floater.side,
          )}`}
        >
          <div className="w-[96rem] max-w-full fixed z-20 rounded-t flex justify-between p-3 font-bold text-sm place-items-center items-center text-shade-blue border-b bg-white">
            <div className="flex items-center">
              <p className="text-lg text-gray-800">Notes: </p>
              <span className="text-[16px] ml-2 italic font-semibold">
                {getOpenLoanDisplayNo(loanDetail)}
              </span>
            </div>

            <button className="hover:underline hover-shadow1 p-1 rounded" onClick={onShowSlide}>
              {floater.side === 'left' ? (
                <ArrowLeftCircleIcon className="w-5 h-5" />
              ) : (
                <ArrowRightCircleIcon className="w-5 h-5" />
              )}
            </button>
          </div>
          <div className="pt-14 h-fit overflow-auto relative text-sm text-gray-900">
            <Notes child={true} />
          </div>
        </div>
      )}
    </>
  )
}
